<template>
  <div class="progress">
    <div class="lampHolder"/>
    <div class="progress-Img">
    <svg viewBox="0 0 100 100">
      <defs>
        <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#830525"/>
          <stop offset="30%" stop-color="#E44067"/>
          <stop offset="65%" stop-color="#FAFF00"/>
          <stop offset="100%" stop-color="#FAFF00"/>
        </linearGradient>
        <filter id="blurFilter">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
      </defs>
      <path :d="path3" stroke="#FFFFFF52" stroke-width="0.75" stroke-linecap="round" fill="none"/>
      <path :d="path2" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" fill="none" filter="url(#blurFilter)"/>
      <path :d="path2" stroke="#ffffff" stroke-width="3" stroke-linecap="round" fill="none"/>
      <path :d="path" stroke="url(#gradient)" stroke-width="3" stroke-linecap="round" fill="none"/>
    </svg>
    </div>
<!--    <span class="rightProgress" v-if="progressText && progressText.length < 11">-->
<!--      {{ progressText }}-->
<!--    </span>-->
<!--    <span class="rightProgress" style="margin-right: 6px" v-else>-->
<!--      {{ progressText.split('/')[0] }}/<br>-->
<!--      {{ progressText.split('/')[1] }}-->
<!--    </span>-->
    <div class="lamp" :style="{backgroundImage:'url('+require('../../assets/images/diwali/lamp.png')+')'}"></div>
  </div>
</template>

<script>
export default {
  name: 'ArcuateProgress',
  props: ['progressEnd', 'progressText'],
  data () {
    return {
      progress: 0,
      interval: null
    }
  },
  computed: {
    path () {
      const cx = 50
      const cy = 50
      const r = 40
      const startAngle = -208
      const endAngle = this.progress / 100 * 208 - 208
      const x1 = cx + r * Math.cos(startAngle * Math.PI / 208)
      const y1 = cy + r * Math.sin(startAngle * Math.PI / 208)
      const x2 = cx + r * Math.cos(endAngle * Math.PI / 208)
      const y2 = cy + r * Math.sin(endAngle * Math.PI / 208)
      const largeArcFlag = endAngle - startAngle <= 208 ? 0 : 1
      return `M ${x1} ${y1} A ${r} ${r} 0 ${largeArcFlag} 1 ${x2} ${y2}`
    },
    path2 () {
      const cx = 50
      const cy = 50
      const r = 40
      const startAngle = -208
      const endAngle = 100 / 100 * 208 - 208
      const x1 = cx + r * Math.cos(startAngle * Math.PI / 208)
      const y1 = cy + r * Math.sin(startAngle * Math.PI / 208)
      const x2 = cx + r * Math.cos(endAngle * Math.PI / 208)
      const y2 = cy + r * Math.sin(endAngle * Math.PI / 208)
      const largeArcFlag = endAngle - startAngle <= 208 ? 0 : 1
      return `M ${x1} ${y1} A ${r} ${r} 0 ${largeArcFlag} 1 ${x2} ${y2}`
    },
    path3 () {
      const cx = 50
      const cy = 50
      const r = 36
      const startAngle = -208
      const endAngle = 100 / 100 * 208 - 208
      const x1 = cx + r * Math.cos(startAngle * Math.PI / 208)
      const y1 = cy + r * Math.sin(startAngle * Math.PI / 208)
      const x2 = cx + r * Math.cos(endAngle * Math.PI / 208)
      const y2 = cy + r * Math.sin(endAngle * Math.PI / 208)
      const largeArcFlag = endAngle - startAngle <= 208 ? 0 : 1
      return `M ${x1} ${y1} A ${r} ${r} 0 ${largeArcFlag} 1 ${x2} ${y2}`
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      if (this.progress < this.progressEnd) {
        this.progress = this.progress + (this.progressEnd / 100)
      }
    }, 5)
  },
  methods: {
    fetchData () {
      console.log(this.userInfo)
    }
  }
}
</script>

<style>
.progress {
  position: relative;
  width: 100vw;
  height: 73vw;
  overflow: visible;

  .progress-Img {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 110vw;
    z-index: 4;
  }
}
.lamp {
  position: absolute;
  top: 2vw;
  left: 50%;
  transform: translate(-50%);
  height: 96.52vw;
  width: 100vw;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.lampHolder{
  position: absolute;
  bottom: -51vw;
  left: 50%;
  transform: translate(-50%);
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  width: 100vw;
  height: 89.97vw;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ArcuateProgress/index.vue